<template>
  <div class="Detail">
    <div v-if="show">
      <div
        class="pickerContent"
        :style="{ marginTop: union ? '20px' : '' }"
      >
        <HealthNav
          v-if="
            Number(responseBody.channel) === Number(healthChannelId) &&
              union !== noHeadUnion
          "
        />
        <NavIndex
          v-if="responseBody.channel === 2"
          :cat-list="catList"
          :on-change="onClickNavIndex"
        />
        <GlobalNavIndex
          v-if="responseBody.channel === 998 || responseBody.channel === 18"
          :catList="catList"
          :channelName="TLang('图书', 'my')"
          :on-change="onBookNavChange"
        />
        <GlobalNavIndex
          v-if="responseBody.channel === 999"
          :catList="catList"
          :channelName="TLang('京东优选', 'my')"
          :on-change="onJDNavChange"
        />
        <GlobalNavIndex
          v-if="responseBody.channel === 20"
          :catList="catList"
          :channelName="TLang('小米有品', 'my')"
          :on-change="onXMNavChange"
        />
        <GlobalNavIndex
          v-if="responseBody.channel === 22"
          :catList="catList"
          :channelName="TLang('网易严选', 'my')"
          :on-change="onWYNavChange"
        />
        <GlobalNavIndex
          v-if="responseBody.channel === 17"
          :catList="catList"
          :channelName="TLang('东福超市', 'my')"
          :on-change="onCSNavChange"
        />
        <!--体检频道不显示面包屑-->
        <div
          v-if="
            ![30, 8, Number(healthChannelId)].includes(
              Number(responseBody.channel)
            )
          "
          class="breadCrumb"
        >
          <a
            :href="
              responseBody.channel === 3
                ? '/shop/birthday'
                : responseBody.channel === 998 || responseBody.channel === 18
                  ? '/book'
                  : responseBody.channel === 17
                    ? '/chaoshi'
                    : responseBody.channel === 999
                      ? '/shopHome/?channelId=999'
                      : responseBody.channel === 20
                        ? '/xmlifepc/'
                        : responseBody.channel === 22
                          ? '/wylife/'
                          : '/shop/home'
            "
            target="_self"
          >{{
            responseBody.channel === 3
              ? TLang('生日汇', 'my')
              : responseBody.channel === 998 || responseBody.channel === 18
                ? TLang('图书', 'my')
                : responseBody.channel === 17
                  ? TLang('东福超市', 'my')
                  : responseBody.channel === 999
                    ? TLang('京东优选', 'my')
                    : responseBody.channel === 20
                      ? TLang('小米有品', 'my')
                      : responseBody.channel === 22
                        ? TLang('网易严选', 'my')
                        : TLang('优选生活', 'my')
          }}</a><img class="arrow" :src="require('@assets/images/birthday/arrow.png')" alt=""/>
          <a
            v-if="
              responseBody.categoryName &&
                responseBody.channel != 998 &&
                responseBody.channel != 18 &&
                responseBody.channel != 17 &&
                responseBody.channel != 999 &&
                responseBody.channel != 20 &&
                responseBody.channel != 22
            "
            :href="`/shop/product/list?categoryId=${responseBody.categoryId}&channelId=${responseBody.channel}&goodsType=0`"
            target="_self"
          >{{ responseBody.categoryName }}<img class="arrow" :src="require('@assets/images/birthday/arrow.png')" alt=""/></a>
          <a
            v-if="
              responseBody.categoryName &&
                (responseBody.channel === 998 || responseBody.channel === 18)
            "
            :href="`/book/list?categoryId=${responseBody.categoryId}&channelId=998`"
            target="_self"
          >{{ responseBody.categoryName }}<img class="arrow" :src="require('@assets/images/birthday/arrow.png')" alt=""/></a>
          <a
            v-if="responseBody.categoryName && responseBody.channel === 999"
            :href="`/shopHome/list?categoryId=${responseBody.categoryId}&channelId=999`"
            target="_self"
          >{{ responseBody.categoryName }}<img class="arrow" :src="require('@assets/images/birthday/arrow.png')" alt=""/></a>
          <a
            v-if="responseBody.categoryName && responseBody.channel === 20"
            :href="`/xmlifepc/list?categoryId=${responseBody.categoryId}&channelId=20`"
            target="_self"
          >{{ responseBody.categoryName }}<img class="arrow" :src="require('@assets/images/birthday/arrow.png')" alt=""/></a>
          <a
            v-if="responseBody.categoryName && responseBody.channel === 22"
            :href="`/wylife/list?categoryId=${responseBody.categoryId}&channelId=22`"
            target="_self"
          >{{ responseBody.categoryName }}<img class="arrow" :src="require('@assets/images/birthday/arrow.png')" alt=""/></a>
          <a
            v-if="responseBody.categoryName && responseBody.channel === 17"
            :href="`/chaoshi/list?categoryId=${responseBody.categoryId}&channelId=17`"
            target="_self"
          >{{ responseBody.categoryName }}<img class="arrow" :src="require('@assets/images/birthday/arrow.png')" alt=""/></a>
          <span>{{ responseBody.name }}</span>
        </div>
        <div
          ref="$main"
          class="main-content"
        >
          <div class="picView">
            <previewPic
              v-if="
                responseBody.goodsImgList && responseBody.goodsImgList.length || responseBody.videoShow
              "
              :pic-list="goodsVideoImgList"
              :stickerImgList="stickerImgList"
              :bizStock="bizStock"
              :video="responseBody.videoShow"
              :videoPic="responseBody.videoShowPic || responseBody.imgGuide"
            />
          </div>
          <div class="descrip">
            <div class="name line-clamp-2">
              <!-- <img
                v-show="newProductTag"
                :src="newProductTag"
                class="new-product-tag"
                alt="新品标签"
              /> -->
              <!-- <span v-if="newProductTag" class="new-product-tag">
                <SingleTag :show="true" :datas="newProductTagInfo" />
              </span> -->
              <span>
                <i
                  v-if="channelTagInfo"
                  class="channel-tag"
                  :style="{ fontStyle: 'normal', position: 'relative', top: '-3px'}"
                >
                  <SingleTag
                    :show="true"
                    :datas="channelTagInfo"
                  />
                </i>
                <i
                  v-if="newProductTag"
                  class="channel-tag"
                  :style="{ fontStyle: 'normal', position: 'relative', top: '-3px', display: 'inline-block'}"
                >
                  <SingleTag
                    :show="true"
                    :datas="newProductTagInfo"
                  />
                </i>
                {{ responseBody.name || "东福商品" }}
              </span>
            </div>
            <div
              v-if="responseBody.subTitle"
              class="subtitle"
            >
              {{ responseBody.subTitle || "" }}
            </div>
            <div
              v-if="responseBody.advanceSale || !!responseBody.preSaleDesc"
              class="desContent-active flex"
              :class="{
                'desContent-active': true,
                flex: true,
                isBilingual: union_isBilingual || CookiesOne && CookiesOne == 'en-US',
              }"
            >
              <div
                class="tag"
                :style="{ marginLeft: union_isBilingual ? '-14px' : '' }"
              >
                {{ TLang('预售','goods') }}
              </div>
              <div class="presell-time">
                <i class="icon iconfont calendar vertical-middle">&#xe64e;</i>
                <span v-if="responseBody.preSaleDesc">{{ responseBody.preSaleDesc }}</span>
                <span v-else>
                  {{ TLang('现在下单','list') }}
                  {{
                    new Date(responseBody.sendGoodsTimeStart)
                      .toLocaleDateString()
                      .replace(/\//g, "-")
                  }}
                  {{ TLang('起开始发货','list') }}
                </span>
              </div>
            </div>
            <div
              v-if="specialPriceShow"
              class="special-price-box"
            >
              <div class="left-side">
                <img
                  src="../../../assets/images/productDetail/super-sale-clock.png"
                  alt=""
                  class="super-sale-clock"
                />
                <span>{{ TLang('限时特价','list') }}</span>
              </div>
              <div class="right-side">
                <span class="limit-time">{{ TLang('距离结束','list') }}</span>
                <span
                  v-if="countObj.day > 0"
                  class="time-item"
                >{{ countObj.day }}
                </span>
                <span v-if="countObj.day > 0">{{ TLang('天','list') }}</span>
                <span class="time-item">{{ countObj.hr }}</span>
                <span>:</span>
                <span class="time-item">{{ countObj.min }}</span>
                <span>:</span>
                <span class="time-item">{{ countObj.sec }}</span>
              </div>
            </div>
            <div
              v-if="rushBuyShow"
              class="rush-buy-box"
            >
              <div class="left-side">
                <div>
                  <img
                    src="../../../assets/images/productDetail/rush-buy-clock.png"
                    alt=""
                    class="rush-buy-img"
                  />
                  <span class="title">{{ TLang('东福抢购','list') }}</span>
                </div>
                <div class="remain">
                  <!-- <div class="outer" v-if="tagInfo.saledRatio">
                    <div class="inner" :style="{ width: tagInfo.saledRatio }">
                      已抢{{ tagInfo.saledRatio }}
                    </div>
                  </div> -->
                  <div
                    v-if="bizStock > 0"
                    class="remain-num"
                  >
                    {{ TLang('仅剩','list') }}{{ bizStock }}{{ TLang('件','list') }}
                  </div>
                  <div
                    v-if="responseBody.stockNum > 0 && bizStock === null"
                    class="remain-num"
                  >
                    {{ ReplaceText("X",responseBody.stockNum,TLang("仅剩X件",'list',false,false,null),false) }}
                    <!-- {{TLang('仅剩','list')}}{{ responseBody.stockNum }}{{TLang('件','list')}} -->
                  </div>
                </div>
              </div>
              <div class="right-side">
                <span class="limit-time">{{ TLang('距离结束','list') }}</span>
                <span
                  v-if="countObj.day > 0"
                  class="time-item"
                >{{
                  countObj.day
                }}</span>
                <span v-if="countObj.day > 0">{{ TLang('天','list') }}</span>
                <span class="time-item">{{ countObj.hr }}</span>
                <span>:</span>
                <span class="time-item">{{ countObj.min }}</span>
                <span>:</span>
                <span class="time-item">{{ countObj.sec }}</span>
              </div>
            </div>
            <div
              v-if="responseBody && responseBody.groupItem === 'Y'"
              class="fpp-part"
            >
              <FppGoodsPrice
                :type="responseBody.groupItemClassStyle"
                :price="responseBody.groupItemPrice"
                :limitPrice="responseBody.groupItemPriceLimit"
                :unionIcon="union_icon || require('@/assets/images/fudou.png')"
                :showSymbolIcon="responseBody.groupItemShowRmbSymbol"
                fontType="detail"
              />
              <div class="fpp-part-spuCode">
                {{ TLang('商品编码','list') }}：{{
                  responseBody.spuCode
                }}
              </div>
            </div>
            <div
              v-else
              :class="{
                'price-bg': true,
                noDisCount: discountPrice === null || !discount,
              }"
            >
              <div class="current-price flex">
                <span class="price-title">{{ TLang('售价','my') }}</span>
                <div class="price">
                  <img
                    :src="union_icon || defaultIcon"
                    alt=""
                    class="fudou-new"
                  />
                  <span
                    v-if="responseBody.price"
                    class="price-number"
                  >
                    {{(promPrice || responseBody.price || 0.0) * union_scale}}
                  </span>
                  <img v-if="purplePriceIcon" class="line-price-purple" :src="purplePriceIcon.mktIcon || defaultPurpleIcon">
                  <div
                    v-if="responseBody.price && promPrice"
                    class="line-price-box"
                  >
                    <img
                      :src="union_icon || defaultLineIcon"
                      style="filter: grayscale(1)"
                      alt
                      class="fudou"
                      v-if="!union_strikethroughPriceIcon"
                    />
                    <img
                      :src="union_strikethroughPriceIcon"
                      alt
                      class="fudou"
                      v-if="union_strikethroughPriceIcon"
                    />
                    <span class="line-price-num">{{
                      (salePrice || responseBody.price || 0.0) * union_scale
                    }}</span>
                  </div>
                  <span
                    v-if="responseBody.isShowDiscountTag === '1'"
                    class="discountTag"
                  >{{ TLang('限时特惠','list') }}</span>
                </div>
                <div class="spuCode">
                  {{ TLang('商品编码','list') }}：{{
                    responseBody.spuCode
                  }}
                </div>
              </div>
              <div class="discountPriceWrap">
                <DiscountPrice
                  :discountPrice="discountPrice"
                  :discount="discount"
                  :discountTagShow="discountTagShow"
                  :mktTagShow="mktTagShow"
                  tipType="detail"
                />
              </div>
            </div>
            <!-- 京东优选 -->
            <div
              v-if="
                responseBody.preciseDeliveryMsg && responseBody.deliveryWay === '2'
              "
              class="delivery"
            >
              <span v-html="responseBody.preciseDeliveryMsg"></span>
            </div>

            <div :style="{ marginTop: '10px' }">
              <AddressRow
                :stock-freight="{
                  stockStatusName: responseBody.stockStatusName,
                  stockStatus: responseBody.stockStatus,
                  goodsFreight: responseBody.goodsFreight,
                  packageMailDesc: responseBody.packageMailDesc,
                  freightShowType: responseBody.freightShowType,
                  freeShipMoney: responseBody.freeShipMoney,
                  postageMoney: responseBody.postageMoney,
                  freeShipWeight: responseBody.freeShipWeight,
                  postageWeight: responseBody.postageWeight,
                  bizStock: bizStock,
                  status: responseBody.status,
                }"
                :epidemicDeliverInfo="epidemicDeliverInfo"
                :onAddressChange="this.onAddressChange"
                :showFeight="false"
              />
            </div>
            <efficiency-date
              :data="responseBody"
              type="detail"
            ></efficiency-date>
            <div
              v-if="responseBody.goodsLogistics"
              class="delivery clearfix"
            >
              <img
                v-if="responseBody.goodsLogistics.deliveryPicUrl"
                :src="responseBody.goodsLogistics.deliveryPicUrl"
                style="width: 89px; height: 23px; margin-right: 4px"
                class="fl"
              />
              <div
                v-if="responseBody.goodsLogistics.consignmentTimeTips"
                class="logWarmTip fl"
              >
                ({{ responseBody.goodsLogistics.consignmentTimeTips }})
              </div>
            </div>
            <div
              v-if="totalLimit > 0 || fullMinus"
              class="disCountDesc"
            >
              <span class="label">{{ TLang('优惠','list') }}</span>
              <div class="item-desc">
                <div
                  v-if="fullMinus"
                  style="height:auto;margin-bottom:10px"
                >
                  <div class="icon-dis">
                    {{ TLang('满减','list') }}
                  </div>
                  <div style="width: 80%;display: flex;flex-wrap: wrap;">
                    <span
                      v-for="(item, index) of fullMinus.rulesDtos"
                      :key="index"
                    >
                      {{ item.assembleRuleDesc }}
                      <span
                        v-if="index < fullMinus.rulesDtos.length - 1"
                      >，</span>
                    </span>
                  </div>
                </div>
                <div v-if="totalLimit > 0">
                  <div
                    class="icon-dis"
                    style="width:60px"
                  >
                    {{ TLang('专享限购','list') }}
                  </div>
                  <span>{{ TLang('购买不超过','list') }}{{ totalLimit }}{{ TLang('件享受优惠专享价剩余可购','list') }}:{{
                    canBuyNum
                  }}{{ TLang('商品以非专享价进行结算','list') }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="responseBody.channel != 2"
              class="weight"
              :style="{ marginTop: '24px' }"
            >
              <span>{{ TLang('重量','my') }}</span><span
                v-if="responseBody.specWeight1 && responseBody.specWeight1 > 0"
                class="weightInfo"
              >{{ responseBody.specWeight1 }}kg</span><span
                v-else
                class="weightInfo"
              >{{ TLang('不计重量','list') }}</span>
            </div>
            <div
              class="freight clearfix"
              style="margin-top: 24px;white-space: inherit;"
            >
              <span class="fl">{{ TLang('运费','orderConfirm') }}</span><span class="freightInfo fl">{{
                getFreightText(responseBody)
              }}</span>
              <div
                v-if="showFreightTips && responseBody.stockStatus != 4"
                class="tips"
              >
                {{ TLang('收货地址修改，运费发生变化', 'orderConfirm') }}
              </div>
            </div>
            <div
              v-if="responseBody.afterSalesPolicyText"
              class="afterSalePolicy"
              style="margin-top: 24px;white-space: inherit;"
            >
              <span>{{ TLang('服务','goods') }}</span><span class="policyInfo">{{ responseBody.afterSalesPolicyText }}</span>
            </div>
            <div
              class="spec"
              :style="{ minHeight: '50px' }"
            >
              <SpecRow
                v-if="
                  responseBody.goodsSpecList &&
                    responseBody.goodsSpecList.length > 0
                "
                :spec-list="responseBody.goodsSpecList"
                :on-change="handleSpecChange"
              />
            </div>
            <div
              v-if="responseBody.accessoryList && responseBody.accessoryList.length > 0"
              class="parts"
              :style="{ marginBottom: '24px',marginTop:'8px' }"
            >
              <div>{{ TLang('配件','my') }}</div>
              <div class="partsInfo">
                <em
                  v-for="(item, index) in responseBody.accessoryList"
                  :key="index"
                >{{ item.accessoryContent }}{{ index < responseBody.accessoryList.length -1 ? ',' : '' }}
                </em>
              </div>
            </div>
            <div class="stepper-wrap">
              <span :style="{color: '#999'}">{{ TLang('数量','orderConfirm') }}</span>
              <StepperRow
                :on-change="handleStepperChange"
                :buy-limit="responseBody.buyLimit"
                :defaultValue="responseBody.buyMin"
                :buy-min="
                  typeof responseBody.buyMin === 'object'
                    ? 0
                    : responseBody.buyMin
                "
                :stock-num="responseBody.stockNum"
                :bizStock="bizStock"
                :isCart="false"
              />
            </div>
            <div
              v-if="promotionBody"
              class="giver-row"
            >
              <span>{{ TLang('赠品','list') }}</span>
              <span class="giver-name">{{
                promotionBody.goodsName || "商品名称"
              }}</span>
              <span
                class="explain"
              >{{ TLang('说明一个礼','list') }}</span>
            </div>
            <MainBtnGroup
              :isGray="isGray"
              :responseBody="responseBody"
              :onClickAddCart="onClickAddCart"
              :onClickGoBuy="onClickGoBuy"

              :shareImgVisible="shareImgVisible"
              :fromCMS="fromCMS"

              :bizStock="bizStock"
              :epidemicDeliverInfo="epidemicDeliverInfo"
              @onClickShare="onClickShare"
            ></MainBtnGroup>
            <!--  -->
          </div>
        </div>
        <div class="rich-recent">
          <div class="rich-content">
            <RichText
              :propertyInfoList="getNewPropertyList(responseBody.propertyInfoList)"
              :goodsDescriptionList="responseBody.goodsDescriptionList"
              :warmReminder="responseBody.warmReminder"
              :jphProductDescUrl="responseBody.jphProductDescUrl"
              :imgListTop="imgListTop"
              :imgListBottom="imgListBottom"
              :imgSales="responseBody.afterSalesPolicyImage"
            />
          </div>
          <div
            v-if="recentData.length > 0"
            class="recent"
          >
            <RecentScan :list="recentData" />
          </div>
        </div>
      </div>
      <div :class="{ 'sticky-btns': true, active: showStickyTop }">
        <div class="btn-content">
          <h4>{{ TLang('商品详情','list') }}</h4>
          <div class="right_btns">
            <MainBtnGroup
              :isGray="isGray"
              :responseBody="responseBody"
              :onClickAddCart="onClickAddCart"
              :onClickGoBuy="onClickGoBuy"
              :fromCMS="fromCMS"
              :bizStock="bizStock"
            ></MainBtnGroup>
          </div>
        </div>
      </div>
      <FixedButton :channelName="TLang(getChannelName(responseBody.channel), 'my')" />
      <Dialog
        title=" "
        :visible.sync="dialogVisible"
        width="420px"
        custom-class="product-dialog"
        center
        top="50vh"

        @open="dialogVisible = true"
      >
        <img :src="require('../../../assets/images/delete.png')" />
        <div class="title">
          {{ TLang('加入购物车成功','my') }}
        </div>
        <div class="btns">
          <button
            class="close-btn"
            @click="dialogVisible = false"
          >
            {{ TLang('继续购物','list') }}
          </button>
          <button
            class="buy-btn primary"
            @click="onClickGoBuy"
          >
            {{ TLang('去结算','my') }}
          </button>
        </div>
      </Dialog>
      <Dialog
        :visible.sync="shareVisible"
        width="345px"
        custom-class="product-share"
        center
      >
        <img
          class="share-img"
          :src="shareImgUrl"
        >
        <button class="detail-share">
          <img
            class="detail-share-img"
            src="@/assets/images/icon-down.png"
            alt=""
          >
          <span
            class="detail-share-btn"
            @click="onDownloadImage"
          >{{ TLang('保存到本地','my') }}</span>
        </button>
      </Dialog>
    </div>
    <div
      v-if="emptyShow"
      class="empty"
    >
      <Empty />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import previewPic from "@components/previewPicVideo";
import NavIndex from "./../../lifeIndex/NavIndex";
import BookNavIndex from "./../../book/NavIndex";
import JDNavIndex from "./../../JDLife/NavIndex";
import GlobalNavIndex from "./GlobalNav/NavIndex";
import Empty from "../Empty/index.vue";
import AddressRow from "./AddressRow";
import SpecRow from "./SpecRow";
import StepperRow from "./StepperRow";
import RecentScan from "./RecentScan";
import RichText from "./RichText";
import HealthNav from "@components/nav/HealthNav";
import MainBtnGroup from "./MainBtnGroup";
import localUrl from "@utils/localUrl.js";
import { fetchaddCart, getActivityTag } from "@fetch/shopping";
import { Dialog } from "element-ui";
import Toast from "@components/simpleToast";
import EfficiencyDate from "@components/efficiencyDate";
import Loading from "@components/SimpleLoading";
import SingleTag from '@components/singleTag';
import FixedButton from "@components/FixedButton";
import DiscountPrice from "./../../lifeIndex/DiscountPrice";
import FppGoodsPrice from '@components/FppGoodsPrice';
import {setTitleInfo} from '@utils/title';


import {
  getProductInfo,
  fetchProductListById,
  fetchRecentScan,
  fetchNavCategory,
  promotionGoods,
  getAds,
  fetchGoodsTags,
  groductShare,
  getCompanyConfig,
} from "@fetch";
import {
  getQueryString,
  unionFlag,
  getHourTime,
  getNextDay,
  plusZero,
  gioClickHandle,
  downloadImage,
  toQsPlus,
  getCorpDomain,
  fromQs,
} from "@utils";
import Cookies from "js-cookie";
import { healthChannelId, noHeadUnion } from "@utils/config";
export default {
  name: "Detail",
  components: {
    previewPic,
    NavIndex,
    BookNavIndex,
    JDNavIndex,
    GlobalNavIndex,
    Empty,
    AddressRow,
    SpecRow,
    StepperRow,
    RecentScan,
    RichText,
    HealthNav,
    MainBtnGroup,
    Dialog,
    EfficiencyDate,
    DiscountPrice,
    SingleTag,
    FppGoodsPrice,
    FixedButton,
  },
  data() {
    return {
      defaultIcon: 'https://fecdn.dongfangfuli.com/mall/images/mallIcon/icon_fudou_h5.png',
      defaultLineIcon: 'https://fecdn.dongfangfuli.com/mall/images/mallIcon/icon_fudou_delete_h5.png',
      defaultPurpleIcon: 'https://fecdn.dongfangfuli.com/mall/images/mallIcon/purple_icon_h5.png',
      shareImgUrl: '',
      shareVisible: false,
      show: false,
      emptyShow: false,
      picList: [],
      pointNewConfirm: false, // 灰度 true跳到新的确认订单页 false 老的确认订单页
      responseBody: {},
      goodsVideoImgList: [],
      catList: [], // 优选的分类 生日汇没有分类
      addressInfo: Cookies.get("address") && JSON.parse(Cookies.get("address")),
      choosenGoods: {
        categoryId:
          getQueryString("cid") ||
          getQueryString("cId") ||
          getQueryString("categoryId"),
        goodsId:
          getQueryString("gid") ||
          getQueryString("gId") ||
          getQueryString("goodsId"),
        goodsNum: 1,
      },
      imgListTop: [],
      imgListBottom: [],
      imgSales: "",
      union: unionFlag(),
      dialogVisible: false,
      showStickyTop: false, //吸顶
      fromCMS: false,
      isGray: false, // 商品由于库存或者下架 不能购买
      recentData: [], // 最近列蓝
      promotionBody: null, // 赠品显示
      healthChannelId: healthChannelId, // 健康商城channelId
      union: unionFlag(),
      noHeadUnion: noHeadUnion,
      isInTime: false, //是否在抢购或者特价活动内
      promPrice: "", //活动价
      salePrice: "", //永久售价
      bizStock: null, // 活动业务库存 为0时展示：抢光了
      _interval: "",
      countObj: {
        day: "99",
        hr: "99",
        min: "99",
        sec: "99",
      },
      mktFrontType: "",
      tagInfo: {},
      rushBuyShow: false,
      specialPriceShow: false,
      isUnfinishScrollBury: true,
      stickerImgList: [], // 商品详情的爆炸贴信息
      newProductTag: "", // 新品标签
      newProductTagInfo: {}, // 新品标签信息
      channelTagInfo: {}, // 频道标签信息
      epidemicDeliverInfo: {
        allowDelivery: null,
        mandatoryType: null,
        promptWords: null,
      },
      discount: null, //折扣比
      discountPrice: null, //折后价格
      discountTagShow: null, //折扣标签是否显示（0否、1是
      mktTagShow: null, //活动标签是否显示（0否、1是
      totalLimit: 0, //限制购买数
      saleNum: 0, //活动期间此人已购买
      purplePriceIcon: null, //紫V标
      fullMinus: null,
      CookiesOne:Cookies.get('df_lang'),
      showFreightTips: false, // 运费变化提示
      oldElectronicFenceFreight: null, // 上次地址运费
      clickAddress: false, // 是否切换了地址
    };
  },
  computed: {
    ...mapGetters("shopCart", ["getCount"]),
    // 折扣活动可购买数
    canBuyNum() {
      const num = (this.totalLimit || 0) - (this.saleNum || 0);
      if (num > 0) {
        return num;
      }
      return 0;
    },
  },
  async mounted() {
    // 如果cookie里面没有id 不要调接口
    await this.init();
    const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
    // const {name, price, imgGuide} = body;
    if (window.df_sdk_common.isBfd()) {
      getCompanyConfig().then(body => {
        const {data} = body || {};
        this.shareImgVisible = (data && data.baseConfig && data.baseConfig.entityGoodShare == 1);
      });
    }

    this.rememberThisSku();
    if (Number(this.responseBody.channel) === 998) {
      // 图书分类
      fetchProductListById({ channelId: 998 }).then((body) => {
        this.catList = body.categoryDtos[998];
      });
    } else if (Number(this.responseBody.channel) === 18) {
      // 图书分类
      fetchProductListById({ channelId: 18 }).then((body) => {
        this.catList = body.categoryDtos[18];
      });
    } else if (Number(this.responseBody.channel) === 999) {
      // 京东优选分类
      fetchProductListById({ channelId: 999 }).then((body) => {
        this.catList = body.categoryDtos[999];
      });
    } else if (Number(this.responseBody.channel) === 20) {
      // 小米有品分类
      fetchProductListById({ channelId: 20 }).then((body) => {
        this.catList = body.categoryDtos[20];
      });
    } else if (Number(this.responseBody.channel) === 22) {
      // 网易严选分类
      fetchProductListById({ channelId: 22 }).then((body) => {
        this.catList = body.categoryDtos[22];
      });
    } else if (Number(this.responseBody.channel) === 17) {
      // 东福超市分类
      fetchProductListById({ channelId: 17 }).then((body) => {
        this.catList = body.categoryDtos[17];
      });
    } else {
      fetchNavCategory({ channelId: 2 }).then((res) => {
        if (res && res[0]) {
          this.catList = res[0].categoryDtoList;
        }
      });
    }

    if (
      document.referrer &&
      document.referrer.match(/backend\.test+|\.ocjfuli/)
    ) {
      this.fromCMS = true;
    }
    window.addEventListener("scroll", this.listenScroll, false);
    // 移除提交订单页指定日期配送上次选中的日期缓存
    window.sessionStorage.removeItem("pcDeliverWay3");
  },
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
    clearInterval(this._interval);
  },
  methods: {
    onDownloadImage() {
      downloadImage(this.shareImgUrl);
    },
    ...mapActions("shopCart", ["cartCount"]),
    async init() {
      await this.fetchProductInfo({
        categoryId: getQueryString("cid") || getQueryString("categoryId"),
        goodsId: getQueryString("gid") || getQueryString("goodsId"),
        ...this.addressInfo,
      });
      this.cartCount({ ...this.addressInfo });
      this.getPromotion();
    },
    listenScroll() {
      let rect = this.$refs.$main.getBoundingClientRect();
      const { top, height } = rect;
      this.showStickyTop = top + height < 0;

      // 进入商品详情页后滑动页面触发(一次)
      if (this.isUnfinishScrollBury) {
        // debugger;
        try {
          const responseBody = this.responseBody || {};
          const gioParams = {
            df_pagename: "商品详情页",
            df_goodsname: responseBody.name || "",
            df_spu_code: responseBody.spuCode || "",
            df_channle: this.getChannelName(+responseBody.channel),
          };
          gioClickHandle("DF_pageView", gioParams);
        } catch (err) {
          console.log(`进入商品详情页后滑动页面触发: ${err}`);
        }
        this.isUnfinishScrollBury = false;
      }
    },
    // 埋点频道名
    getChannelName(channel) {
      switch (channel) {
      case 3:
        return '生日汇';
      case 998:
        return '图书';
      case 18:
        return '图书';
      case 999:
        return '京东优选';
      case 20:
        return '小米有品';
      case 22:
        return '网易严选';
      case 17:
        return '东福超市';
      default:
        return '优选生活';
      }
    },
    getAdsData(goods) {
      this.imgListTop = [];
      this.imgListBottom = [];
      getAds({
        type: unionFlag() ? 2 : 1,
        bannerLocList: [17, 18],
        goodsId: goods ? goods.goodsId : getQueryString("gid"),
        categoryId: goods ? goods.categoryId : getQueryString("cid"),
      }).then((res) => {
        // console.log(res);
        if (res) {
          res.map((item) => {
            if (item.locationCode === 17 && item.imgList.length) {
              item.imgList.map((img) =>
                this.imgListTop.push({
                  imgUrl: img.imgUrl,
                  url: item.url,
                }),
              );
            } else if (item.locationCode === 18 && item.imgList.length) {
              item.imgList.map((img) =>
                this.imgListBottom.push({
                  imgUrl: img.imgUrl,
                  url: item.url,
                }),
              );
            }
          });
        }
      });
    },
    rememberThisSku() {
      let pre_cookie =
        (localStorage.getItem("dffl_recent_scan") &&
          JSON.parse(localStorage.getItem("dffl_recent_scan") || "[]")) ||
        [];
      if (pre_cookie.length) {
        // 如果没有就把商品加到第一位， 有就调整到第一位， 确保第一位是最新浏览到
        if (!pre_cookie.includes(this.responseBody && this.responseBody.id)) {
          pre_cookie.splice(0, 0, this.responseBody.id);
          localStorage.setItem("dffl_recent_scan", JSON.stringify(pre_cookie));
        } else {
          pre_cookie.map((item, index) => {
            if (this.responseBody && this.responseBody.id === item) {
              pre_cookie.splice(0, 0, pre_cookie.splice(index, 1)[0]);
              localStorage.setItem(
                "dffl_recent_scan",
                JSON.stringify(pre_cookie),
              );
            }
          });
        }
      } else {
        localStorage.setItem(
          "dffl_recent_scan",
          JSON.stringify([this.responseBody.id]),
        );
      }
      let params = [];
      pre_cookie.map((id) => {
        if (this.responseBody && id !== this.responseBody.id) {
          params.push({ id });
        }
      });
      // 取params的前20个
      this.getRecentScanData(params.slice(0, 20));
    },
    // 电子围栏运费提示
    electronicFenceFreightShow() {
      this.showFreightTips = true;
      setTimeout(() => {
        this.showFreightTips = false;
      }, 5000);
    },
    //请求商品信息
    async fetchProductInfo(opt) {
      Loading.show();
      return getProductInfo({
        ...opt,
        preview: getQueryString("preview") === "1",
        appId: '100037',
      }).then((body) => {
        Loading.hide();

        // 是否指向新的权益前置的订单确认页
        if(body){
          this.pointNewConfirm = body.pointNewConfirm? body.pointNewConfirm : false;
        }

        if (body && body.goodsId) {
          if ((body.oldElectronicFenceFreight || body.oldElectronicFenceFreight === 0 ) && body.oldElectronicFenceFreight != body.electronicFenceFreight) {
            this.electronicFenceFreightShow();
          }

          setTitleInfo({goodsName: body.name});

          // 进页面首次加载
          if (!this.show) {
            this.getAdsData();
            this.show = true;
          }
          this.responseBody = body;
          this.getNewImgList(body);
          if (
            (body.stockStatus === 1 || body.stockStatus === 2) &&
            body.goodsStatus == "1"
          ) {
            this.epidemicDeliverInfo = body.specialArea;
          }
          this.countObj = {
            day: "99",
            hr: "99",
            min: "99",
            sec: "99",
          };
          this._interval && clearInterval(this._interval);
          getActivityTag({
            channel: 2,
            goodsList: [{ categoryId: body.categoryId, goodsId: body.goodsId }],
            returnLimit: true,
          }).then((res) => {
            //mktFrontType   1001 特价 1004 抢购  2001 满减  9001 新品
            // 京东优选展示新品标签/特价抢购标签,不展示满减标签
            // 详情商品爆炸贴
            this.stickerImgList = res[0].tags.filter((item) => item.type === 2);
            // 满减
            this.fullMinus = res[0].tags.find(
              (item) => item.mktFrontType === 2001,
            );
            // 业务库存
            this.bizStock = res[0].bizStock >= 0 ? res[0].bizStock : null;
            // 详情商品新品标签
            let newProductTagList = res[0].tags.filter(
              (item) => item.type === 3,
            );
            if (newProductTagList.length > 0) {
              this.newProductTag = newProductTagList[0].mktIcon;
              this.newProductTagInfo = newProductTagList[0];
            }
            // 详情商品频道标签
            let channelTagList = res[0].tags.filter(
              (item) => item.mktFrontType === 9005,
            );
            if (channelTagList.length > 0) {
              this.channelTagInfo = channelTagList[0];
            }
            //判断是否存在折扣价,有折扣价说明存在特价/抢购活动
            if (res[0].promPrice) {
              let saleTag = res[0].tags.find(
                (item) =>
                  item.mktFrontType === 1001 || item.mktFrontType === 1004,
              );
              let startTime = saleTag.startTime;
              let endTime = saleTag.endTime;
              let startDate = Date.parse(startTime);
              let endDate = Date.parse(endTime);
              let now = new Date().getTime();
              let ms = endDate - now;
              if (now < endDate && now > startDate) {
                this.countdown(ms / 1000);
              } else {
                this.rushBuyShow = false;
                this.specialPriceShow = false;
                this.promPrice = "";
                return;
              }
              this.promPrice = res[0].promPrice;
              // this.mktFrontType = res[0].tags[0].mktFrontType;
              this.mktFrontType = saleTag.mktFrontType;

              this.salePrice = res[0].salePrice || "";
              if (this.mktFrontType === 1004) {
                //抢购
                this.rushBuyShow = true;
                this.specialPriceShow = false;
              }
              if (this.mktFrontType === 1001) {
                // 限时特价
                this.specialPriceShow = true;
                this.rushBuyShow = false;
              }
            } else {
              this.rushBuyShow = false;
              this.specialPriceShow = false;
              this.promPrice = "";
              clearInterval(this._interval);
            }
            // 折扣
            const tagInfo = res[0] || {};
            this.discount = tagInfo.discount; //折扣比
            this.discountPrice = tagInfo.discountPrice; //折后价格
            this.discountTagShow = tagInfo.discountTagShow; //折扣标签是否显示（0否、1是
            this.mktTagShow = tagInfo.mktTagShow;
            this.totalLimit = tagInfo.totalLimit || 0;
            this.saleNum = tagInfo.saleNum || 0;
            this.purplePriceIcon = tagInfo.tags.find((item) => item.mktFrontType == 11001)
          });


          let specTagList = [];
          body &&
            body.goodsSpecList &&
            body.goodsSpecList.map((sku) => {
              if (this.choosenGoods.goodsId == sku.goodsId) {
                this.isGray = sku.gray;
              }
              if (sku.goodsId && sku.categoryId) {
                specTagList.push({
                  goodsId: sku.goodsId,
                  categoryId: sku.categoryId,
                });
              }
            });
          // 增加规格的tags请求，查询商品规格的业务库存。因为spec的gray字段跟随大库。所以需另外请求tags接口查询业务锁库情况
          // 产品表示后端无时间改，需要前端调整，页面上出现二次刷新的情况不用处理。因此多写了以下这一段代码。
          specTagList.length > 0 &&
            getActivityTag({
              channel: 2,
              goodsList: specTagList,
            }).then((res) => {
              body.goodsSpecList.map((sku) => {
                const goodTag = res.find(
                  (tag) =>
                    tag.categoryId == sku.categoryId &&
                    tag.goodsId == sku.goodsId,
                );
                const bizStock =
                  goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
                this.$set(sku, "bizStock", bizStock);
              });
            });

          if (
            this.responseBody.mallSpuId &&
            !localUrl.getQueryString("mallSpuId")
          ) {
            this.$router.replace({
              query: {
                ...this.$route.query,
                mallSpuId: this.responseBody.mallSpuId,
              },
            });
          }
          if (
            Number(this.responseBody.channel) === Number(this.healthChannelId)
          ) {
            document.title = `${this.TLang('东方福利网', 'my')} - ${this.TLang('健康商城', 'my')}`;
          }
          if (Number(this.responseBody.channel) === 3) {
            document.title = `${this.TLang('生日汇', 'my')} - ${this.TLang('商品详情页', 'goods')}`;
          }
          if (
            Number(this.responseBody.channel) === 998 ||
            Number(this.responseBody.channel) === 18
          ) {
            document.title = `${this.TLang('图书', 'my')} - ${this.TLang('商品详情页', 'goods')}`;
          }
          if (Number(this.responseBody.channel) === 999) {
            document.title = `${this.TLang('京东优选', 'my')} - ${this.TLang('商品详情页', 'goods')}`;
          }
          if (Number(this.responseBody.channel) === 20) {
            document.title = `${this.TLang('小米有品', 'my')} - ${this.TLang('商品详情页', 'goods')}`;
          }
          if (Number(this.responseBody.channel) === 22) {
            document.title = `${this.TLang('网易严选', 'my')} - ${this.TLang('商品详情页', 'goods')}`;
          }
          if (Number(this.responseBody.channel) === 17) {
            document.title = `${this.TLang('东福超市', 'my')} - ${this.TLang('商品详情页', 'goods')}`;
          }
        } else {
          this.emptyShow = true;
          document.title = this.TLang('商品详情页', 'goods');
        }
      });
    },
    // 获取图片列表和视频信息
    getNewImgList(productDetail) {
      let arr = [];
      arr = productDetail.goodsImgList;
      if (productDetail.videoShow) {
        arr.unshift({
          type: 'video',
          path: productDetail.videoShow,
        });
        this.goodsVideoImgList = arr;
      } else {
        this.goodsVideoImgList = productDetail.goodsImgList;
      }
    },
    // 获取赠品信息
    getPromotion() {
      promotionGoods({ ...this.choosenGoods, ...this.addressInfo }).then(
        (body) => {
          if (body && body.goodsName) {
            this.promotionBody = body;
          } else {
            this.promotionBody = null;
          }
        },
      );
    },
    // 获取用户浏览信息
    getRecentScanData(params) {
      let sortData = [];
      let renderData = [];
      if (params.length) {
        fetchRecentScan({ list: params }).then((res) => {
          let goodsList = [];
          res.forEach((item) => {
            if (item.categoryId && item.goodsId) {
              goodsList.push({
                goodsId: item.goodsId,
                categoryId: item.categoryId,
              });
            }
          });
          //获取浏览记录商品对应的标签
          fetchGoodsTags({
            goodsList: goodsList,
            channel: 2,
          }).then((tagList) => {
            if (tagList && tagList.length > 0) {
              res.forEach((item) => {
                const goodTag =
                  tagList.find((tag) => {
                    return (
                      tag.categoryId == item.categoryId &&
                      tag.goodsId == item.goodsId
                    );
                  }) || {};
                let tags = goodTag && goodTag.tags ? goodTag.tags : [];
                //商品详情-最近浏览不展示新品标签
                let newTags = tags.filter((item) => item.type === 1 || item.mktFrontType === 9003 || item.mktFrontType === 9004 || item.mktFrontType === 9005);
                let stickerImgList = tags.filter((item) => item.type === 2);
                const promPrice =
                  goodTag && goodTag.tags ? goodTag.promPrice : null;
                const salePrice =
                  goodTag && goodTag.tags ? goodTag.salePrice : null;
                const bizStock =
                  goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
                this.$set(item, "tags", newTags);
                this.$set(item, "promPrice", promPrice);
                this.$set(item, "salePrice", salePrice);
                this.$set(item, "bizStock", bizStock);
                //爆炸贴数据
                this.$set(item, "stickerImgList", stickerImgList);
                // 拼接折扣信息
                this.$set(item, "discount", goodTag.discount);
                this.$set(item, "discountPrice", goodTag.discountPrice);
                this.$set(item, "discountTagShow", goodTag.discountTagShow);
                this.$set(item, "mktTagShow", goodTag.mktTagShow);

                // 福拼拼相关字段
                // Y 为福拼拼
                this.$set(item, "groupItem", goodTag.groupItem);
                // groupItemClassStyle 样式 1、文本模式，2、+货币模式
                this.$set(item, "groupItemClassStyle", goodTag.groupItemClassStyle);
                // 拼团价格
                this.$set(item, "groupItemPrice", goodTag.groupItemPrice);
                // 拼团价格限制 最高可抵扣福豆
                this.$set(item, "groupItemPriceLimit", goodTag.groupItemPriceLimit);
                // 拼团商品是否显示人命币 Y:是 N:否
                this.$set(item, "groupItemShowRmbSymbol", goodTag.groupItemShowRmbSymbol );
              });
              // 爆炸贴数据
              // 先按传参排序 再转化为二维 5个一组
              if (res.length) {
                params.map((item) => {
                  res.map((goods) => {
                    if (item.id === goods.id) {
                      sortData.push(goods);
                    }
                  });
                });
              }
              if (sortData.length) {
                sortData.map((goods, index) => {
                  let page = Math.floor(index / 5);
                  if (!renderData[page]) {
                    renderData[page] = [];
                  }
                  renderData[page].push(goods);
                });
                this.recentData = renderData;
              }
            } else {
              // 先按传参排序 再转化为二维 5个一组
              if (res.length) {
                params.map((item) => {
                  res.map((goods) => {
                    if (item.id === goods.id) {
                      sortData.push(goods);
                    }
                  });
                });
              }
              if (sortData.length) {
                sortData.map((goods, index) => {
                  let page = Math.floor(index / 5);
                  if (!renderData[page]) {
                    renderData[page] = [];
                  }
                  renderData[page].push(goods);
                });
                this.recentData = renderData;
              }
            }
          });
          // // 先按传参排序 再转化为二维 5个一组
          // if (res.length) {
          //   params.map((item) => {
          //     res.map((goods) => {
          //       if (item.id === goods.id) {
          //         sortData.push(goods);
          //       }
          //     });
          //   });
          // }
          // if (sortData.length) {
          //   sortData.map((goods, index) => {
          //     let page = Math.floor(index / 5);
          //     if (!renderData[page]) {
          //       renderData[page] = [];
          //     }
          //     renderData[page].push(goods);
          //   });
          //   this.recentData = renderData;
          //   console.log(this.recentData,'recentData')
          // }
        });
      }
    },
    onClickAddCart() {
      // debugger;
      // 点击加入购物车/立即购买时触发
      if (this.bizStock === 0) return;
      try {
        const responseBody = this.responseBody || {};
        const gioParams = {
          df_channle: this.getChannelName(+responseBody.channel),
          df_pagename: "频道首页",
          df_modulename: "快捷按钮",
          df_elementname: "加入购物车",
          df_goodsname: responseBody.name || "",
          df_spu_code: responseBody.spuCode || "",
        };
        gioClickHandle("DF_elementClick", gioParams);
      } catch (err) {
        console.log(`点击加入购物车/立即购买时触发: ${err}`);
      }
      if (
        this.epidemicDeliverInfo.allowDelivery === 0 &&
        this.epidemicDeliverInfo.mandatoryType === 0
      )
        return;
      if (this.responseBody.goodsStatus === "1" && !this.fromCMS) {
        fetchaddCart(
          Object.assign({}, this.choosenGoods, this.addressInfo),
        ).then((res) => {
          if (res === "成功") {
            this.dialogVisible = true;
          } else if (res.code === 999999) {
            Toast.info(res.msg, 1);
          }
        });
      }
    },
    onClickShare() {

      const query = fromQs();
      const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
      const {name, price, imgGuide} = this.responseBody;
      // 去域名化改造：前端生成现状拼接域名，需要接口支持可去除域名
      groductShare({
        content:  toQsPlus(`${window.df_sdk_common ? window.df_sdk_common.getH5LocationOriginByPcUrl() : ''}/tmall/product/detail?`, {
          gid: query.gid || query.gId,
          cid: query.cid || query.cId,
          channelId: '',
          union: unionF,
          from: 'qrcode',
        }),
        productId: query.gid || query.gId,
        productName: name,
        price:  parseFloat(((this.discountPrice || this.promPrice  || price) * union_scale)),
        picUrl: imgGuide,
        unionName: this.mallUnionConfigDto.customerName,
      }).then(body => {
        this.shareImgUrl =  body.picUrl;
        this.shareVisible = true;
      });
    },
    onClickGoBuy() {
      if (this.bizStock === 0) return;
      try {
        if (this.responseBody.status != "2") {
          // 点击加入购物车/立即购买时触发
          const responseBody = this.responseBody || {};
          const gioParams = {
            df_channle: this.getChannelName(+responseBody.channel),
            df_pagename: "频道首页",
            df_modulename: "快捷按钮",
            df_elementname: "立即购买",
            df_goodsname: responseBody.name || "",
            df_spu_code: responseBody.spuCode || "",
          };
          gioClickHandle("DF_elementClick", gioParams);
        }
      } catch (err) {
        console.log(`点击加入购物车/立即购买时触发: ${err}`);
      }
      const buyGoodsList = [
        {
          ...this.choosenGoods,
          num: this.choosenGoods.goodsNum,
        }
      ];
      let ORDER_PATH = `/shop/order/confirm?orderType=2&buyGoodsList=${encodeURIComponent(
        JSON.stringify(buyGoodsList),
      )}`;
      let ORDER_NEW_PATH = `/shop/order/confirmNew?orderType=2&buyGoodsList=${encodeURIComponent(
        JSON.stringify(buyGoodsList),
      )}`;
      // if (window.location.hostname === "www.chailesemanager.dongfangfuli.com") {
      //   // pointNewConfirm
      //   ORDER_PATH = `/shop/order/confirmTest?orderType=2&buyGoodsList=${encodeURIComponent(
      //     JSON.stringify(buyGoodsList)
      //   )}`;
      //   ORDER_NEW_PATH = `/shop/order/confirmTest?orderType=2&buyGoodsList=${encodeURIComponent(
      //     JSON.stringify(buyGoodsList)
      //   )}`;
      // }
      // if (window.location.hostname === "www.chailesemanager.dongfangfuli.com") {
      //   ORDER_PATH = `/shop/order/confirmTest?orderType=2&buyGoodsList=${encodeURIComponent(
      //     JSON.stringify(buyGoodsList)
      //   )}`;
      // }
      if (
        this.epidemicDeliverInfo.allowDelivery === 0 &&
        this.epidemicDeliverInfo.mandatoryType === 0
      )
        return;
      if (
        this.responseBody.goodsStatus === "1" &&
        ((this.responseBody.stockStatus < 3 &&
          !this.isGray &&
          this.bizStock === null) ||
          this.bizStock > 0) &&
        !this.fromCMS
      ) {
        this.apis.headerApi.getLoginStatus().then((res) => {
          sessionStorage.setItem("loginInfo", JSON.stringify(res));
          debugger;
          if (res.loginFlag) {
            if (this.pointNewConfirm){
              window.df_sdk_common.location.href = ORDER_NEW_PATH;
            } else{
              window.df_sdk_common.location.href = ORDER_PATH;
            }
          } else {
            Toast.info(this.TLang('请重新登录', 'goods'), 1, () => {
              if (this.pointNewConfirm){
                window.df_sdk_common.location.href =
                res.loginUrl +
                "&return_url=" +
                window.location.origin +
                ORDER_NEW_PATH;
              }else{
                window.df_sdk_common.location.href =
                res.loginUrl +
                "&return_url=" +
                window.location.origin +
                ORDER_PATH;
              }
            });
          }
        });
      }
    },
    // 获取选择的规格商品 sku
    handleSpecChange(goods) {
      this.clickAddress = true;
      this.oldElectronicFenceFreight = this.responseBody.electronicFenceFreight,
      this.fetchProductInfo({
        categoryId: goods.categoryId,
        goodsId: goods.goodsId,
        ...this.addressInfo,
        oldElectronicFenceFreight: this.responseBody.electronicFenceFreight,
      });
      this.choosenGoods.categoryId = goods.categoryId;
      this.choosenGoods.goodsId = goods.goodsId;
      this.getPromotion();
      this.$router.replace({
        query: {
          ...this.$route.query,
          gid: goods.goodsId,
          cid: goods.categoryId,
        },
      });
      this.getAdsData(goods);
    },
    // 获取选择的数量
    handleStepperChange(val) {
      this.choosenGoods.goodsNum = val;
    },
    // 获取地址
    onAddressChange(address) {
      this.addressInfo = address;
      Cookies.set("address", address, { expires: 365 });
      // console.log("Cookies.set7", address);
      this.oldElectronicFenceFreight = this.responseBody.electronicFenceFreight,
      this.clickAddress = true;
      this.fetchProductInfo({
        ...this.choosenGoods,
        ...this.addressInfo,
        oldElectronicFenceFreight: this.responseBody.electronicFenceFreight,
      });
      this.getPromotion();
    },
    // 分类埋点
    clickNavGioHandle(id, name) {
      try {
        let navInfo = {},
          isFirstNav = (this.catList || []).some((li = {}) => li.id == id);
        // 点击一级分类/点击二级分类
        let gioParams = {
          df_channle: this.getChannelName(+(this.responseBody || {}).channel),
          df_pagename: "商品详情页",
          df_modulename: "分类导航",
          df_elementname: isFirstNav ? "一级分类" : "二级分类",
          df_firstCategory: name,
          df_firstCategoryId: id + "",
        };
        gioClickHandle("DF_elementClick", gioParams);
      } catch (err) {
        console.log(`点击一级分类/点击二级分类: ${err}`);
      }
    },
    onClickNavIndex(id, item) {
      this.clickNavGioHandle(id, item.name);
      window.df_sdk_common.location.href = `/shop/product/list?categoryId=${id}`;
    },

    /**
     * 精准配送截单时间和最早发货日期
     * @param { Number } preciseDeliveryDay  提前时间 0当天  1明天
     * @param { Array } preciseDeliveryConfig  配送时间段
     * @param { String } preciseDeliveryConfig  可选最早发货时间
     * @param { String } cutOffTimeStr  截单时间
     */
    getPrecisionDeliveryText(
      preciseDeliveryDay,
      preciseDeliveryConfig,
      earliestDeliveryTime,
      cutOffTimeStr,
    ) {
      const nowTime = new Date().getTime();
      const deadlineDate =
        new Date().toLocaleDateString() + " " + cutOffTimeStr;
      const deadlineTime = new Date(deadlineDate).getTime();
      const lastHour = preciseDeliveryConfig[preciseDeliveryConfig.length - 1]; // 可选最后时间段
      const lastTime = getHourTime(new Date().toLocaleDateString(), lastHour);
      if (+preciseDeliveryDay > 1) {
        //大于明天
        return nowTime > deadlineTime
          ? this.ReplaceText('HHHH', cutOffTimeStr, this.ReplaceText('QQQQ', getNextDay(earliestDeliveryTime), this.TLang('后下单起发货', 'goods')))
          : this.ReplaceText('HHHH', cutOffTimeStr, this.ReplaceText('QQQQ', earliestDeliveryTime, this.TLang('前下单起发货', 'goods')));
      }

      if (+preciseDeliveryDay === 1) {
        //明天
        return nowTime > deadlineTime
          ? this.ReplaceText('HHHH', cutOffTimeStr, this.ReplaceText('QQQQ', getNextDay(earliestDeliveryTime), this.TLang('后下单起发货', 'goods')))
          : this.ReplaceText('HHHH', cutOffTimeStr, this.TLang('前下单次日发货', 'goods'));
      }

      //今天
      if (nowTime > deadlineTime)
        return this.ReplaceText('HHHH', cutOffTimeStr, this.TLang('后下单次日发货', 'goods')); //过了截单时间
      if (lastTime - 3 * 60 * 60 * 1000 >= deadlineTime)
        return this.ReplaceText('HHHH', cutOffTimeStr, this.TLang('前下单今日发货', 'goods'));
      const allowDay = new Date(lastTime - 3 * 60 * 60 * 1000);
      const allowTime =
        plusZero(allowDay.getHours()) + ":" + plusZero(allowDay.getMinutes());
      return this.ReplaceText('HHHH', allowTime, this.TLang('后下单次日发货', 'goods'));
    },
    onBookNavChange(id, item) {
      this.clickNavGioHandle(id, item.name);
      window.df_sdk_common.location.href = `/book/list?categoryId=${id}&channelId=998`;
    },
    onJDNavChange(id) {
      window.df_sdk_common.location.href = `/shopHome/list?categoryId=${id}&channelId=999`;
    },
    onXMNavChange(id) {
      window.df_sdk_common.location.href = `/xmlifepc/list?categoryId=${id}&channelId=20`;
    },
    onWYNavChange(id) {
      window.df_sdk_common.location.href = `/wylife/list?categoryId=${id}&channelId=22`;
    },
    onCSNavChange(id) {
      window.df_sdk_common.location.href = `/chaoshi/list?categoryId=${id}&channelId=17`;
    },
    //活动倒计时
    countdown(countTime) {
      this._interval = setInterval(() => {
        // console.log(countTime,'countTime')
        if (countTime < 0) {
          // 计时结束，清除
          clearInterval(this._interval);
          location.reload();
        } else {
          countTime--;
          let day = parseInt(countTime / 60 / 60 / 24);
          let hr = parseInt((countTime / 60 / 60) % 24);
          let min = parseInt((countTime / 60) % 60);
          let sec = parseInt(countTime % 60);

          day = day > 9 ? day : "0" + day;
          hr = hr > 9 ? hr : "0" + hr;
          min = min > 9 ? min : "0" + min;
          sec = sec > 9 ? sec : "0" + sec;
          this.day = day;
          this.hr = hr;
          this.min = min;
          this.sec = sec;
          this.countObj = {
            day,
            hr,
            min,
            sec,
          };
        }
      }, 1000);
    },
    /**
     * 获取运费信息
     * @param { json } info  信息
     * @return { String }  src  运费描述
     */
    getFreightText(info) {
      let str = this.TLang('免运费', 'orderConfirm');
      if (info.electronicFenceFlag) {
        if (info.stockStatus === 4) {
          str = this.TLang('不支持配送', 'list');
        }
        else if (info.electronicFenceFreight) {
          str = `${parseFloat((info.electronicFenceFreight * union_scale))}${window.union_name || this.TLang('福豆', 'my')}`;
        } else {
          str = this.TLang('免运费', 'orderConfirm');
        }
      } else if (info.freightShowType) {
        switch (info.freightShowType) {
        case 1:
          str = this.TLang('免运费', 'orderConfirm');
          break;
        case 2:
          // str = `${this.TLang('实付金额满', 'my')}${parseFloat(
          //   (info.freeShipMoney * union_scale).toFixed(2)
          // )}${window.union_name || this.TLang('福豆', 'my')}${this.TLang('包邮不满时需支付基础运费', 'my')}${parseFloat(
          //   (info.postageMoney * union_scale).toFixed(2)
          // )}${window.union_name || this.TLang('福豆', 'my')}`;
          str = this.ReplaceText(
            'MMM',
            parseFloat((info.freeShipMoney * union_scale)),
            this.ReplaceText(
              'YYY',
              parseFloat((info.postageMoney * union_scale)),
              this.ReplaceText(
                'UUU',
                window.union_name || this.TLang('福豆', 'card'),
                this.TLang('实付金额满包邮不满运费', 'goods'),
                true,
              ),
            ));
          break;
        case 3:
          // str = `${this.TLang('免运费', 'orderConfirm')}（${info.freeShipWeight}kg${this.TLang('内包邮超重', 'my')}${parseFloat(
          //   (info.postageWeight * union_scale).toFixed(2)
          // )}${window.union_name || this.TLang('福豆', 'my')}/kg）`;
          str = this.ReplaceText(
            'MMM',
            info.freeShipWeight,
            this.ReplaceText(
              'CCC',
              parseFloat((info.postageWeight * union_scale)),
              this.ReplaceText(
                'UUU',
                window.union_name || this.TLang('福豆', 'card'),
                this.TLang('免运费超重', 'goods'),
                true,
              ),
            ));
          break;
        case 4:
          // str = `${this.TLang('实付金额满', 'my')}${parseFloat(
          //   (info.freeShipMoney * union_scale).toFixed(2)
          // )}${window.union_name || this.TLang('福豆', 'my')}（${
          //   info.freeShipWeight
          // }kg${this.TLang('内', 'my')}）${this.TLang('包邮不满时需支付基础运费', 'my')}${parseFloat(
          //   (info.postageMoney * union_scale).toFixed(2)
          // )}${window.union_name || this.TLang('福豆', 'my')}，${this.TLang('续重', 'my')}${parseFloat(
          //   (info.postageWeight * union_scale).toFixed(2)
          // )}${window.union_name || this.TLang('福豆', 'my')}/kg`;
          str = this.ReplaceText(
            'MMM',
            parseFloat((info.freeShipMoney * union_scale)),
            this.ReplaceText(
              'YYY',
              parseFloat((info.postageMoney * union_scale)),
              this.ReplaceText(
                'QQQ',
                info.freeShipWeight,
                this.ReplaceText(
                  'CCC',
                  parseFloat((info.postageWeight * union_scale)),
                  this.ReplaceText(
                    'UUU',
                    window.union_name || this.TLang('福豆', 'card'),
                    this.TLang('实付金额满包邮不满运费续重', 'goods'),
                    true,
                  ),
                ),
              ),
            ));
          break;
        default:
          break;
        }
      } else if (!info.freightShowType && info.goodsFreight === 0) {
        str = this.TLang('免运费', 'orderConfirm');
      } else if (!info.freightShowType && info.packageMailDesc) {
        str = info.packageMailDesc
          .replace(/(\d)(\.)?(\d+)?/g, ($0) => $0 * union_scale)
          .replace(/福豆/g, window.union_name || this.TLang('福豆', 'my'));
      }
      return str;
    },
    /**
     * 获取参数规格信息
     * @param { array } list  规格列表
     * @return { array }  重组顺序后的列表
     */
    getNewPropertyList(list){
      if (list && list.length > 0) {
        let brandArr = list.filter(spec => spec.specName.indexOf('品牌') > -1) || [];
        let noBrandArr = list.filter(spec => spec.specName.indexOf('品牌') < 0) || [];
        brandArr.push.apply(brandArr, noBrandArr);
        return brandArr;
      } else {
        return [];
      }
    },
  },
};
</script>
<style lang="less">
.Detail {
  .arrow {
    width: 16px;
    height: 16px;
    margin: 0 5px;
  }
  .pickerContent {
    width: 1200px;
    margin: 0 auto;
    .breadCrumb {
      line-height: 50px;
      color: #666;
      a {
        color: #666;
      }
    }
    .main-content {
      display: flex;
      .picView {
        min-width: 420px;
      }
      .descrip {
        margin-left: 40px;
        flex: 1;
        .word {
          font-size: 13px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
        .name {
          max-width: 720px;
          font-size: 24px;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 6px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .presell-time {
          padding-left: 30px;
        }
        .subtitle {
          font-size: 13px;
          font-weight: 300;
          color: rgba(153, 153, 153, 1);
          line-height: 18px;
          margin-top: 8px;
        }
        .desContent-active {
          width: 100%;
          background: url("../../../assets/images/productDetail/presell-bg.png")
            #f2f2f2 no-repeat;
          background-size: contain;
          margin-top: 14px;
          height: 36px;
          line-height: 36px;
          color: rgba(255, 255, 255, 1);
          padding: 0 24px;
          box-sizing: border-box;
          .tag {
            border-radius: 2px 0px 0px 0px;
            font-size: 14px;
            font-weight: 500;
            background: transparent;
            color: #fff;
          }
          .presell-time {
            padding-left: 30px;
            font-size: 14px;

            i {
              vertical-align: bottom;
            }
          }
        }
        .special-price-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 740px;
          height: 36px;
          padding: 7px 16px 8px 16px;
          box-sizing: border-box;
          background: linear-gradient(192deg, #ffaf00 0%, #f44545 100%);
          color: #ffffff;
          .left-side {
            margin-left: 10px;
            font-size: 16px;
            font-weight: bold;
            .super-sale-clock {
              width: 25px;
              height: 25px;
              vertical-align: middle;
            }
          }
          .right-side {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 6px;
            margin-bottom: 6px;
            .limit-time {
              font-size: 14px;
              // margin-right: 5px;
            }
            .time-item {
              padding: 3px 5px 3px 5px;
              background: linear-gradient(342deg, #555555 0%, #333333 100%);
              border-radius: 2px;
              margin-left: 5px;
              margin-right: 5px;
              // font-size: 14px;
            }
          }
        }
        .rush-buy-box {
          width: 740px;
          height: 61px;
          box-sizing: border-box;
          padding-left: 25px;
          padding-right: 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: linear-gradient(192deg, #ffaf00 0%, #f44545 100%);
          color: #ffffff;
          .left-side {
            img {
              width: 30px;
              height: 30px;
              vertical-align: middle;
            }
            .title {
              font-size: 16px;
              font-weight: bold;
              color: #ffffff;
            }
            .remain {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              // margin-top: 8px;
              .outer {
                width: 142px;
                height: 14px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 12px;
              }
              .inner {
                // width: 50%;
                height: 14px;
                background: rgba(255, 255, 255, 0.8);
                border-radius: 12px;
                text-align: center;
                white-space: nowrap;
                line-height: 14px;
                color: #f44545;
                font-size: 12px;
              }
              .remain-num {
                // margin-left: 16px;
                margin-left: 36px;
              }
            }
          }
          .right-side {
            .limit-time {
              font-size: 14px;
              margin-right: 5px;
            }
            .time-item {
              padding: 3px 5px 3px 5px;
              background: linear-gradient(342deg, #555555 0%, #333333 100%);
              border-radius: 2px;
              // font-size: 14px;
            }
          }
        }
        .current-price {
          width: 100%;
          padding-top: 16px;
          /* background: url("../../../assets/images/productDetail/price-bg.png")
            no-repeat; */
          /* line-height: 60px; */
          color: rgba(153, 153, 153, 1);
          box-sizing: border-box;
          /* padding: 0 10px; */
          .spuCode {
            margin-left: auto;
          }
          span {
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            // margin-top: 10px;
          }
          .price-title {
            margin-top: 7px;
          }
          .price {
            padding-left: 20px;
            line-height: 1.1;
            display: flex;
            align-items: center;
            .fudou-new {
              height: 14px;
              margin-top: 5px;
            }
            .price-number {
              font-size: 25px;
              font-weight: 500;
              color: #FF5757;
              img {
                vertical-align: baseline;
              }
            }
            .line-price-purple {
              width: 14px;
              height: 14px;
              margin: 0 5px;
            }
            .line-price-box {
              display: inline;
              position: relative;
              display: flex;
              align-items: center;
              margin-left: 3px;
              margin-top: 8px;
              .line-price-num {
                font-size: 14px;
                color: #999999;
                line-height: 12px;
                text-decoration: line-through;
              }
              .fudou {
                width: 15px;
                height: 15px;
                margin-top: 0;
                vertical-align: middle;
                // -webkit-filter: grayscale(100%);
                // -moz-filter: grayscale(100%);
                // -ms-filter: grayscale(100%);
                // -o-filter: grayscale(100%);
                // filter: grayscale(100%);
                // filter: gray;
                // opacity: 0.7;
              }
              // &:after {
              //   content: "";
              //   width: calc(100% - 12px);
              //   height: 1px;
              //   position: absolute;
              //   left: 14px;
              //   top: 5px;
              //   background-color: #999999;
              //   // transform: scaleY(0.5);
              // }
            }

            .discountTag {
              background: #fff7e6;
              padding: 0 10px;
              color: #ffaf00;
              font-size: 14px;
              border-radius: 8px;
              line-height: 24px;
              display: inline-block;
              margin-left: 15px;
            }
          }
        }
        .spec {
          margin-top: 24px;
        }
        .delivery {
          margin-top: 18px;
          margin-left: 50px;
          margin-bottom: 16px;
          img {
            width: 18px;
            height: 18px;
          }
          span {
            font-size: 14px;
            color: #666;
          }
        }

        .stepper-wrap {
          display: flex;
          align-items: center;
          /deep/ span {
            color: #999;
          }
        }
        .giver-row {
          font-size: 14px;
          color: #111;
          text-align: center;
          display: flex;
          align-items: center;
          // margin-left: 45px;
          margin-top: 25px;
          span {
            color: #999;
            font-size: 12px;
          }
          .giver-name {
            line-height: 32px;
            margin-left: 24px;
            color: #111;
            // font-size: 14px;
          }
          .explain {
            margin-left: 15px;
            color: #999;
            line-height: 32px;
          }
        }
      }
    }
    .rich-recent {
      display: flex;
      .rich-content {
        margin-top: 70px;
        flex: 1;
      }
      .recent {
        margin-top: 70px;
        margin-left: 24px;
        width: 290px;
      }
    }
  }
  .sticky-btns {
    border-bottom: 1px solid #b2b2b2;
    position: fixed;
    width: 100%;
    top: -81px;
    background: #fff;
    z-index: 996;
    transition: top 300ms ease;
    .btn-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h4 {
        font-size: 24px;
        color: rgba(61, 150, 226, 1);
        line-height: 80px;
        position: relative;
        &:after {
          content: "";
          width: 96px;
          height: 4px;
          background: rgba(61, 150, 226, 1);
          position: absolute;
          left: 0;
          bottom: 0;
          display: inline-block;
        }
      }
      .main-btns {
        margin: 0;
      }
    }
  }
  .active {
    top: 0;
  }
  .empty {
    min-height: 600px;
  }
  .new-product-tag {
    width: 34px;
    margin-right: 3px;
  }
  .logWarmTip {
    font-size: 12px;

    color: #999;
    line-height: 23px;
  }
  .discountPriceWrap {
    width: 100%;
    height: 28px;
    padding-left: 45px;
  }
  .price-bg {
    width: 100%;
    height: 88px;
    background: url("../../../assets/images/productDetail/price-bg.png")
      no-repeat;
    box-sizing: border-box;
    padding: 0 10px;
  }
  .noDisCount {
    height: 60px;
    .current-price {
      height: 60px;
      line-height: 60px;
      padding-top: 0 !important;
    }
  }
  .disCountDesc {
    display: flex;
    width: 90%;
    .item-desc {
      width: 100%;
      & > div {
        display: flex;
        height: 38px;
        font-size: 14px;
        color: #333333;
        line-height: 19px;
      }
    }
    .icon-dis {
      padding: 0px 6px;
      height: 16px;
      text-align: center;
      border-radius: 8px;
      border: 1px solid;
      margin-right: 8px;

      font-size: 11px;
      font-weight: 400;
      color: #f75e35;
      line-height: 16px;
    }
    span {
      font-size: 14px;
      color: #333333;
    }
    .label {
      margin-right: 10px;
      font-size: 12px;
      color: #999999;
      width: 45px;
    }
  }
  .weight {
    color: #999;
    font-size: 13px;
    .weightInfo {
      color: #333;
      margin-left: 24px;
      font-size: 14px;
    }
  }
  .parts{
    color: #999;
    font-size: 13px;
    display: flex;
    flex-wrap: wrap;
  }
  .partsInfo {
      color: #333;
      margin-left: 24px;
      font-size: 14px;
      max-width: 670px;
      word-wrap:break-word;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  .freight {
    color: #999;
    font-size: 13px;
    position: relative;
    overflow: visible;
    .freightInfo {
      color: #333;
      margin-left: 24px;
      font-size: 14px;
      max-width: 670px;
    }
    .tips {
      position: absolute;
      left: 50px;
      top: -40px;
      width: auto;
      max-width: 250px;
      font-size: 12px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 17px;
      padding: 9px 10px;
      background: rgba(0,0,0,0.7);
      z-index: 9;
      white-space: pre-wrap;
      box-shadow: 0px 2px 8px 0px rgba(53, 59, 64, 0.15);
      border-radius: 4px;
      box-sizing: content-box;
      &::after {
        content: '';
        display: inline-block;
        position: absolute;
        bottom: -14px;
        left: 10px;
        border: 7px solid;
        border-color: rgba(0,0,0,0.7) transparent transparent;
      }
    }
  }
  .afterSalePolicy {
    color: #999;
    font-size: 13px;
    position: relative;
    overflow: visible;
    .policyInfo {
      color: #333;
      margin-left: 24px;
      font-size: 14px;
    }
  }
  .fpp-part{
    height: 65px;
    background: linear-gradient(270deg, #FF5757 0%, #FF5C37 100%);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    &-spuCode{
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
    }
  }

}
.product-share {
  background: transparent;
}

.detail-share {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  background: #FFFFFF;
  border-radius: 4px;
  margin-top: 20px;
  cursor: pointer;


  .detail-share-btn {
    margin-left: 8px;
  }
  .detail-share-img {
    width: 20px;
    height: 20px;
  }
}
.share-img {
  width: 100%;
  height: 520px;
  background: #FFFFFF;
  border-radius: 16px;
}

.product-share.el-dialog {
  box-shadow: none;
  margin:auto;

  .el-dialog__headerbtn .el-dialog__close {
    background: #FFFFFF;
    opacity: 0.75;
    border-radius: 50%;
  }

 .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding-top: 15px;
  }
  .el-dialog__headerbtn {
    top: 0px;
    right: -12px;

    .el-dialog__close {
      font-size: 22px;
    padding: 2px;
    background-color: rgba(255,255,255,.25);
    color: #fff;
    }
  }
}

</style>
